import { post_data } from "../helpers/functions";
import { Fabric } from "./fabric";
import { Sequins } from "./sequins";
import { Yarn } from "./yarn";

class CustomSelect {
  constructor() {
    this.currentPage = 1;
    this.searchTerm = "";
    this.fetching = false;
    this.optionsHidden = true;
  }

  addScrollEventToObject = (div) => {
    const lists = div.querySelectorAll(".custom-select-list");
    lists.forEach((list) => {
      list.addEventListener("scroll", (e) => {
        e.stopPropagation();
        if (
          list.scrollHeight - list.scrollTop === list.clientHeight &&
          !this.fetching
        ) {
          this.currentPage++;
          this.fetchItems();
        }
      });
    });
  };

  fetchItems = async (e = false) => {
    this.fetching = true;
    if (e.type === "input") this.currentPage = 1;
    e && e.stopPropagation();
    const currentField = document.activeElement;
    if (this.optionsHidden) {
      this.optionsHidden = false;
      currentField.parentElement
        .querySelector(".custom-select-list")
        .classList.remove("hidden");
    }
    const fieldName = currentField.getAttribute("data-type");
    const fieldNumber = currentField.getAttribute("data-number") ?? "";
    this.searchTerm = currentField.value;
    const company_id = this.getCookie("selected_company");
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "get_field_data",
        type: fieldNumber,
        name: fieldName,
        currentPage: this.currentPage,
        searchTerm: this.searchTerm,
        company_id: company_id,
      })
    );
    const items = await post_data("./includes/ajax.inc.php", form);
    this.renderItems(items, fieldName);
  };

  renderItems = (items, fieldName) => {
    const itemList = document.activeElement.parentElement.querySelector(
      ".custom-select-list"
    );
    if (this.currentPage === 1) itemList.innerHTML = "";
    if (items === null || items === false) return;

    const allowedNames = [];
    items.forEach((item) => {
      const itemDiv = this.createListItem(fieldName, item);
      itemList.appendChild(itemDiv);
      allowedNames.push(itemDiv.dataset.name);
    });

    const currentInput = document.activeElement;
    currentInput.allowedNames = allowedNames;

    // ✅ Only enforce selection if not "series"
    if (currentInput.id !== "series") {
      currentInput.addEventListener("blur", function () {
        if (!allowedNames.includes(currentInput.value)) {
          currentInput.value = "";
          currentInput.removeAttribute("data-id");
        }
      }, { once: true });
    }

    itemList.querySelectorAll(".custom-select-option.selected").length < 1 &&
      itemList.querySelector(".custom-select-option").classList.add("selected");

    this.fetching = false;
  };



  createListItem = (fieldName, item) => {
    if (fieldName === "yarn") {
      return this.createYarnListItem(item);
    } else if (fieldName === "fabric") {
      return this.createFabricListItem(item);
    } else if (fieldName === "user" || fieldName === "estimated") {
      return this.createUserListItem(item);
    } else {
      return this.createStandardListItem(item);
    }
  };

  createStandardListItem = (item) => {
    const itemDiv = document.createElement("div");
    //prettier-ignore
    const name = item['name'];
    const classNames =
      name === document.activeElement.value
        ? "custom-select-option selected"
        : "custom-select-option";
    Object.assign(itemDiv, {
      id: item["id"],
      className: classNames,
      textContent: item["name"],
    });
    Object.assign(itemDiv.dataset, {
      id: item["id"],
      name,
    });
    return itemDiv;
  };

  createUserListItem = (item) => {
    const itemDiv = document.createElement("div");
    //prettier-ignore
    const name = item["first_name"] + " " + item["last_name"];
    const classNames =
      name === document.activeElement.value
        ? "custom-select-option selected"
        : "custom-select-option";
    Object.assign(itemDiv, {
      id: item["id"],
      className: classNames,
      textContent: name,
    });
    Object.assign(itemDiv.dataset, {
      id: item["id"],
      name,
      abr: item["abr"],
    });
    return itemDiv;
  };

  createYarnListItem = (item) => {
    const itemDiv = document.createElement("div");
    const joinOn = item["third"] === "" ? "" : "/";
    //prettier-ignore
    const name = item['third'] + " " + item['fourth'] + joinOn + item['fifth'];
    const classNames =
      name === document.activeElement.value
        ? "custom-select-option selected"
        : "custom-select-option";
    Object.assign(itemDiv, {
      id: item["id"],
      className: classNames,
      textContent:
        item["name"] +
        " " +
        item["third"] +
        " " +
        item["fourth"] +
        joinOn +
        item["fifth"] +
        " " +
        item["id"],
    });
    Object.assign(itemDiv.dataset, {
      id: item["id"],
      name,
      material: item["name"],
    });
    return itemDiv;
  };

  createFabricListItem = (item) => {
    const itemDiv = document.createElement("div");
    let classNames = "custom-select-option";
    if (
      item["id"] ===
      document.activeElement.parentElement.parentElement.querySelector(
        ".editor-form__id"
      ).value
    ) {
      classNames += " selected";
    }
    Object.assign(itemDiv, {
      id: item["id"],
      className: classNames,
      textContent: item["id"] + " " + item["name"],
    });
    Object.assign(itemDiv.dataset, {
      name: item["name"],
      number: item["id"],
      unstretch: item["third"],
      id: item["id"],
    });
    return itemDiv;
  };

  getSelectedElementIndex = () => {
    const selectOptions = document.activeElement.parentElement.querySelectorAll(
      ".custom-select-option"
    );
    let index = -1;

    for (let i = 0; i < selectOptions.length; i++) {
      if (selectOptions[i].classList.contains("selected")) {
        index = i;
        break;
      }
    }
    return index;
  };

  unselectElementAtIndex = (index) => {
    document.activeElement.parentElement
      .querySelectorAll(".custom-select-option")
      [index].classList.remove("selected");
  };

  selectElementAtIndex = (index) => {
    document.activeElement.parentElement
      .querySelectorAll(".custom-select-option")
      [index].classList.add("selected");
  };

  keyUp = () => {
    const selectedElementIndex = this.getSelectedElementIndex();
    if (selectedElementIndex < 1) return;
    this.unselectElementAtIndex(selectedElementIndex);
    this.selectElementAtIndex(selectedElementIndex - 1);
    this.ensureVisible(selectedElementIndex - 1);
  };

  keyDown = () => {
    const selectedElementIndex = this.getSelectedElementIndex();
    if (
      selectedElementIndex >=
      document.activeElement.parentElement.querySelectorAll(
        ".custom-select-option"
      ).length -
        1
    )
      return;
    if (selectedElementIndex >= 0) {
      this.unselectElementAtIndex(selectedElementIndex);
    }
    this.selectElementAtIndex(selectedElementIndex + 1);
    this.ensureVisible(selectedElementIndex + 1);
  };

  enter = (e) => {
    const currentElement = document.activeElement;
    const selectOption = currentElement.parentElement.querySelector(
      ".custom-select-option.selected"
    );
    if (!selectOption) return;
    e.preventDefault();
    if (currentElement.getAttribute("data-type") === "fabric") {
      this.selectFabricFields(selectOption);
    } else if (currentElement.getAttribute("data-type") === "yarn") {
      this.selectYarn(selectOption);
    } else if (
      currentElement.getAttribute("data-type") === "user" ||
      currentElement.getAttribute("data-type") === "estimated"
    ) {
      this.selectUser(selectOption);
    } else {
      this.selectItemName(selectOption);
    }
  };

  ensureVisible = (index) => {
    const selectOptions = document.activeElement.parentElement.querySelector(
      ".custom-select-list"
    );
    const currentElement =
      document.activeElement.parentElement.querySelectorAll(
        ".custom-select-option"
      )[index];
    const rect = currentElement.getBoundingClientRect();
    const listRect = selectOptions.getBoundingClientRect();

    if (rect.top < listRect.top) {
      // Element is above the visible area
      selectOptions.scrollTop -= listRect.top - rect.top;
      selectOptions.dispatchEvent(new Event("scroll"));
    } else if (rect.bottom > listRect.bottom) {
      // Element is below the visible area
      selectOptions.scrollTop += rect.bottom - listRect.bottom;
      selectOptions.dispatchEvent(new Event("scroll"));
    }
  };

  focusSelect = (e) => {
    this.focusSelectOut();
    this.optionsHidden = false;
    e.target.parentElement
      .querySelector(".custom-select-list")
      .classList.remove("hidden");
    this.fetchItems();
  };

  focusSelectOut = () => {
    let listItems = document.querySelectorAll(".custom-select-list");
    listItems.forEach((item) => {
      item.classList.add("hidden");
      item.innerHTML = "";
    });
    this.currentPage = 1;
    this.optionsHidden = true;
  };

  handleKeyPress = (e) => {
    switch (e.key) {
      case "ArrowUp":
        e.preventDefault();
        this.keyUp(e);
        break;
      case "ArrowDown":
        e.preventDefault();
        this.keyDown(e);
        break;
      case "Enter":
        e.preventDefault();
        this.enter(e);
        break;
      case "Tab":
        this.enter(e);
        break;
      default:
        break;
    }
  };

  selectFabricFields = (el) => {
    const number = el.getAttribute("data-number");
    const text = el.getAttribute("data-name");
    const breite = el.getAttribute("data-unstretch");
    const fieldContainer = el.parentElement.parentElement.parentElement;
    fieldContainer.querySelector(".editor-form__fabric").value = text;
    // after selecting fabric, remove error background color
    fieldContainer.querySelector(".editor-form__fabric").style.backgroundColor = "#444"; // prettier-ignore
    fieldContainer
      .querySelector(".editor-form__fabric")
      .setAttribute("data-id", el.getAttribute("data-id")); // prettier-ignore

    fieldContainer.querySelector(".editor-form__id").value = number;
    fieldContainer.querySelector(".fabric-breite").value = breite;
    customSelect.focusSelectOut();
    Fabric.copyDataToForm(fieldContainer, number, text, breite);
  };

  selectYarn = (el) => {
    const number = el.getAttribute("data-name");
    const fieldContainer = el.parentElement.parentElement.parentElement;
    const material = fieldContainer.querySelector(".custom-material");
    material.value = el.dataset.material;
    material.setAttribute("data-id", el.getAttribute("data-id"));
    // after selecting yarn, remove error background color
    material.style.backgroundColor = "#444";
    const idField = fieldContainer.querySelector(".custom-type");
    idField.value = number;
    idField.setAttribute("data-id", el.getAttribute("data-id"));
    customSelect.focusSelectOut();
    material.dispatchEvent(new Event("input"));
    material.blur();
    idField.dispatchEvent(new Event("input"));
    idField.blur();
  };

  selectItemName = (el) => {
    const name = el.getAttribute("data-name");
    const fieldContainer = el.parentElement.parentElement;
    const field = fieldContainer.querySelector(".editor-form__custom-select");
    field.value = name;
    field.setAttribute("data-id", el.getAttribute("data-id"));
    customSelect.focusSelectOut();
    field.dispatchEvent(new Event("input"));
    field.blur();
    const copyElement = document.querySelector("#copy-" + field.id);
    if (!copyElement) return;
    copyElement.value = name;
  };

  selectUser = (el) => {
    let name = el.getAttribute("data-name");
  
    // Check if the name starts and ends with a hyphen
    if (!/^-\s.*\s-$/.test(name)) {
      // Remove any part of the name in parentheses
      name = name.replace(/\s*\(.*?\)\s*/, "").trim();
  
      // Check if name is in "firstname lastname" format
      const nameParts = name.split(" ");
      if (nameParts.length >= 2) {
        const [firstName, lastName] = nameParts;
        // Abbreviate firstname to its first letter
        name = `${firstName.charAt(0)}. ${lastName}`;
      }
    }
  
    const fieldContainer = el.parentElement.parentElement;
    const field = fieldContainer.querySelector(".editor-form__custom-select");
    field.value = name;
    field.setAttribute("data-id", el.getAttribute("data-id"));
    customSelect.focusSelectOut();
    field.dispatchEvent(new Event("input"));
    field.blur();
    document.querySelector("#copy-" + field.id).value = name;
  };
  

  selectItem = (el) => {
    const currentElement = el.parentElement.parentElement.querySelector(
      ".editor-form__custom-select"
    );
    if (currentElement.getAttribute("data-type") === "fabric") {
      this.selectFabricFields(el);
    } else if (currentElement.getAttribute("data-type") === "yarn") {
      this.selectYarn(el);
    } else if (
      currentElement.getAttribute("data-type") === "user" ||
      currentElement.getAttribute("data-type") === "estimated"
    ) {
      this.selectUser(el);
    } else {
      this.selectItemName(el);
    }
  };

  setDataToFields = (data) => {
    if (!data) return;
    const fields = [
      "collection",
      "series",
      "theme",
      "article",
      "designer",
      "drawer",
      "puncher",
      "estimated",
      "discussed",
    ];
    for (const field of fields) {
      const value = data[field + "_id"];
      const element = document.getElementById(field);
      element.setAttribute("data-id", value);
    }
  };

  getCookie(name) {
    let cookieArr = document.cookie.split(";");

    // Loop through all cookies to find the one with the matching name
    for (let i = 0; i < cookieArr.length; i++) {
        let cookie = cookieArr[i].trim();
        // If cookie name matches the one we want
        if (cookie.startsWith(name + "=")) {
            return cookie.substring(name.length + 1); // Return the value of the cookie
        }
    }
    return null; // Return null if cookie is not found
  };

}

const customSelect = new CustomSelect();

export { customSelect };
